<div>
  <app-header></app-header>
</div>
<div class="blog-detail-container px-3 mt-3" *ngIf="blog">
  <h1 class="blog-title mb-0">{{ blog.title }}</h1>
  <p class="blog-date">
    <strong>Published Date:</strong> {{ formatDate(blog.created_at) || 'N/A' }}
  </p>
  <img [src]="blog.photo || 'https://via.placeholder.com/800x400'" alt="{{ blog.title }}" class="img-fluid blog-image">
  <div>
    <div class="intro-content mt-4">
      <div [innerHTML]="blog.short_description"></div>
    </div>
  </div>
</div>
<div>
  <app-footer></app-footer>
</div>